<template>
  <header>
    <HeaderNavBarSmallScreen v-if="smallViewport" />
    <HeaderNavBarLargeScreen v-if="!smallViewport" />
    <form
      class="flex flex-col pt-4 pb-2 text-gray-600 md:pt-6 md:pb-2 md:max-xl:pt-4 md:max-xl:pb-2 gap-y-4 bg-trublue-100"
    >
      <div class="flex items-center px-4 md:px-8 md:max-xl:flex-wrap">
        <div class="items-center flex-1 block px-4 divide-gray-700 md:flex md:mr-12 md:max-xl:w-full md:max-xl:mr-0">
          <div class="p-1.5 w-full bg-white border border-gray-700 md:w-1/3 mr-1.5 rounded-full">
            <HeaderSearchFormLocation />
          </div>
          <div class="w-full px-4 bg-white border border-gray-700 md:w-1/3 md:block mr-1.5 rounded-full mt-2 md:mt-0">
            <HeaderSearchFormStoreTypes />
          </div>
          <div class="p-1.5 w-full pl-4 pr-2 bg-white border border-gray-700 md:w-1/3 rounded-full mt-2 md:mt-0">
            <HeaderSearchFormStore />
          </div>
        </div>
        <div class="hidden md:flex md:max-xl:w-full md:max-xl:justify-left md:max-xl:mt-4 gap-x-8">
          <div class="flex gap-4 text-sm font-medium">
            {{ t('showList') }}
            <UToggle v-model="ui.showList" toggle="ui.toggleResultsView" class="bg-trublue-700" />
          </div>
        </div>
      </div>
      <div class="flex px-4 mx-auto center text-trublue-700 md:hidden gap-x-6">
        <div :class="!ui.showStoreList ? 'border-b-4 border-trublue-700' : ''">
          <UButton
            variant="ghost"
            @click="ui.showMapView()"
            class="text-base font-bold cursor-pointer text-trublue-700 hover:bg-transparent"
          >
            {{ t('mapView') }}
          </UButton>
        </div>
        <div :class="ui.showStoreList ? 'border-b-4 border-trublue-700' : ''">
          <UButton
            variant="ghost"
            @click="ui.showListView()"
            class="text-base font-bold cursor-pointer text-trublue-700 hover:bg-transparent"
          >
            {{ t('listView') }}
          </UButton>
        </div>
      </div>
    </form>
  </header>
</template>

<script setup lang="ts">
import { breakpointsTailwind, useBreakpoints } from '@vueuse/core'

const breakpoints = useBreakpoints(breakpointsTailwind)
const activeBreakpoints = breakpoints.active()
const { t } = useI18n()
const search = useSearchStore()
const ui = useUiStore()
const smallOrMediumViewport = computed(() => !activeBreakpoints.value || ['xs', 'sm'].includes(activeBreakpoints.value))
const smallViewport = computed(() => !activeBreakpoints.value || ['sm'].includes(activeBreakpoints.value))
</script>
